import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';

@Component({
    selector: 'app-materials-filter-button',
    templateUrl: './materials-filter-button.component.html',
    styleUrls: ['./materials-filter-button.component.scss']
})
export class MaterialsFilterButtonComponent implements OnInit {

    @LocalStorage()
    selectedMaterialCols: string[];

    showAll = true;

    countTypes: any;

    filterIsOn: boolean;

    @Input()
    allMaterialsCols: any;

    @Input()
    cols: any;

    @Output()
    colsEdited = new EventEmitter<void>();

    constructor() { }

    ngOnInit(): void {
        if (typeof this.selectedMaterialCols === 'undefined' || this.selectedMaterialCols === null) {
            this.fillTypes()
        }

        this.filter();
    }

    countTypesMethod() {
        if (this.selectedMaterialCols.length === this.allMaterialsCols.length) {
            this.filterIsOn = false;
        }
        else {
            if (this.selectedMaterialCols) {
                this.countTypes = this.selectedMaterialCols.length
            }

            this.filterIsOn = true;
        }
    }

    fillTypes() {
        this.selectedMaterialCols = this.allMaterialsCols.map(col => {
            return col.field
        })
    }

    clickOnFilter() {
        this.filter()

        this.colsEdited.emit();
    }

    filter() {
        if (this.selectedMaterialCols.length !== this.allMaterialsCols.length) {
            this.showAll = false;
        }
        else if (this.selectedMaterialCols.length === this.allMaterialsCols.length) {
            this.showAll = true;
        }
        this.countTypesMethod()
    }

    showAllButton() {
        if (!this.showAll) {
            this.selectedMaterialCols = [];
        }
        else if (this.showAll) {
            this.fillTypes()
        }
        this.countTypesMethod();

        this.colsEdited.emit();
    }
}
